import React from 'react'
import ReactSelect from "react-select";

const Autocomplete = ({
	options,
	placeholder,
	required,
	className,
	value,
	onChange,
	isClearable,
	getOptionLabel,
	getOptionValue,
	isLoading,
}) => {
	return (
		<ReactSelect
			placeholder={placeholder}
			options={options}
			isClearable={isClearable}
			required={required}
			className={`font-normal text-sm ${className}`}
			getOptionLabel={getOptionLabel}
			getOptionValue={getOptionValue}
			value={value}
			isLoading={isLoading}
			styles={{
				option: (base) => ({
					...base,
					height: '100%',
					borderRadius: 8,
					fontSize: 12,
					fontWeight: 300,
				}),
				menu: (base) => ({
					...base,
					padding: 10,
				}),
			}}
			theme={(theme) => ({
				...theme,
				borderRadius: 8,
				colors: {
					...theme.colors,
					primary25: 'orange',
					primary: 'gray',
				},
				spacing: {
					baseUnit: 5,
					menuGutter: 10,
				},
			})}
			onChange={onChange}
		/>
	)
}

export default Autocomplete